import React from "react";
import { Route, Router, Switch } from "wouter";
import OrderRequestList from "../admin/orderManagement/orderRequest/orderRequestList";
import OrdersList from "../admin/orderManagement/orders/ordersList";
import FailedOrders from "../admin/orderManagement/failedOrders";
import ProductsList from "../admin/productsManagement/productsList";
import ProductsPricingList from "../admin/productsManagement/productPricingList";
import NewOrderRequest from "../admin/orderManagement/orderRequest/newOrderRequest";
import OrderDetailsPage from "../admin/orderManagement/orders/orderDetailsPage";
import OrderRequestDetailsPage from "../admin/orderManagement/orderRequest/orderRequestDetails";
import SubOrdersList from "../admin/orderManagement/orders/subOrders/subOrderList";
import CreateSubOrder from "../admin/orderManagement/orders/subOrders/createSubOrder";
import SubOrdersDetails from "../admin/orderManagement/orders/subOrders/subOrderDetails";
import OrderDraftList from "../admin/orderManagement/orderRequest/orderDraftList";
import Dashboard from "../admin/dashboard/dashboard";
import DealerOrderRequestList from "../admin/orderManagement/orderRequest/dealerOrdersList";
import PendingProjectOrders from "../admin/orderManagement/orders/pendingProjectOrders";
import StockAnalysis from "../admin/Analytics/stockAnalysis";
import ProductPerformance from "../admin/Analytics/productPerformance";
import TopDealers from "../admin/Analytics/topDealers";
import ProductForecasting from "../admin/Analytics/productForecasting";

const ErrorScreen = React.lazy(() => import("../404"));

const AdminRoutes = () => {
  return (
    <Router>
      <React.Suspense>
        <Switch>
          <Route path="/admin/order-requests" component={OrderRequestList} />
          <Route
            path="/admin/dealer-orders"
            component={DealerOrderRequestList}
          />
          <Route
            path="/admin/pending-sub-orders"
            component={PendingProjectOrders}
          />
          <Route path="/admin/orders" component={OrdersList} />
          <Route path="/admin/failed-orders" component={FailedOrders} />
          <Route path="/admin/products-list" component={ProductsList} />
          <Route
            path="/admin/order-requests/new-order"
            component={NewOrderRequest}
          />
          <Route
            path="/admin/order-requests/order-detail"
            component={OrderRequestDetailsPage}
          />
          <Route
            path="/admin/orders/order-detail"
            component={OrderDetailsPage}
          />
          <Route
            path="/admin/orders/sub-order-list"
            component={SubOrdersList}
          />
          <Route
            path="/admin/orders/create-new-order"
            component={CreateSubOrder}
          />
          <Route
            path="/admin/products-pricing"
            component={ProductsPricingList}
          />
          <Route
            path="/admin/orders/sub-order-details"
            component={SubOrdersDetails}
          />
          <Route path="/admin/order-drafts" component={OrderDraftList} />
          <Route path="/admin/dashboard" component={Dashboard} />
          <Route
            path="/admin/analysis/stock-analysis"
            component={StockAnalysis}
          />
          <Route
            path="/admin/analysis/product-performance"
            component={ProductPerformance}
          />
          <Route path="/admin/analysis/top-dealers" component={TopDealers} />
          <Route
            path="/admin/analysis/product-forecast"
            component={ProductForecasting}
          />
          <Route component={ErrorScreen} />
        </Switch>
      </React.Suspense>
    </Router>
  );
};

export default AdminRoutes;
